import React, { useState, useEffect, useRef} from 'react';
import { Form, Row, Col, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { useParams, useNavigate, useLocation} from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';

const CondigurarPagamentoOnlineForm = () => {
  const navigate = useNavigate();
  const { tipo } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const state = queryParams.get('state');

  const {
    crud,
    setTitle
  } = useProvider();
  const { loading, post, patch, get } = crud || {};
  const [configuracoes, setConfiguracoes] = useState([]);
  const [instituicoes, setInstituicoes] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [carregado, setCarregado] = useState(false);
  const popupRef = useRef(null);

  setTitle("Pagamentos Online")
  

  useEffect(() => {
    const timer = setInterval(() => {
      const popup = popupRef.current;
      if (popup && popup.closed) {
        clearInterval(timer);
        buscarInicializacao();
        //alert("A janela foi fechada!");
        console.log("A janela foi fechada!");
      }
    }, 500);

    return () => clearInterval(timer);
  }, []);


  useEffect(()=>{
    const callback = async()=>{
      try{
        const dados = {
          code,
          state
        };
        
        const query = new URLSearchParams(dados).toString();
        
        const response = await get(`/pagamento-online/integracao/${tipo}/callback/?${query}`);
        //alert(JSON.stringify(response));
        window.close();
        Toast.fire({
          icon: 'success',
          title: 'Configurado com sucesso',
        });
      }catch(err){
        alert(JSON.stringify(err.response))
      }
    }
    if(tipo){
      callback();
    }
  },[tipo])
  
  const configurarInstituicao = async(instituicao)=>{
    try{
      const response = await get(`/pagamento-online/integracao/${instituicao}/auth/`);
      //alert(JSON.stringify(response));
      if(response && response.length){
        popupRef.current = window.open(response[0].autoriza_url, "popup");
      }
    }catch(err){
      alert(JSON.stringify(err.response))
    }
  }
  const mudarStatus = async(instituicao, ativo)=>{
    try{
      const config = selectConfiguracao(instituicao);
      const response = await patch({
        "ativo":ativo
      },`/pagamento-online/configuracoes/${config.id}/`);
      alert(JSON.stringify(response));
      if(response && response.length){
        buscarInicializacao();
      }
    }catch(err){
      alert(JSON.stringify(err.response))
    }
  }
  
  // const handleSubmit = async (e) => {
  //   if (e) e.preventDefault();

  //   const errors = {};


  //   if (Object.keys(errors).length > 0) {
  //     setFormErrors(errors);
  //     return;
  //   }

  //   setFormErrors({});


  //   const formData = new FormData();
  //   formData.append('instituicao', configuracao.instituicao || ``);
  //   formData.append('ativo', configuracao.ativo || false);

  //   const apiRequest = configuracao.id ? patch : post;

  //   try {
  //     const response = await apiRequest(
  //       formData,
  //       `/pagamento-online/configuracao/${configuracao.id || ''}${configuracao.id ? '/' : ''}`,
  //       'multipart/form-data'
  //     );

  //     if (response && response.length) {
  //       setConfiguracao(response[0]);
  //       Toast.fire({
  //         icon: 'success',
  //         title: 'Configuração salva com sucesso',
  //       });
  //       //navigate(-1);
  //     }
  //   } catch (err) {
  //     alert(JSON.stringify(err.response))
  //     const errorMessage =
  //       typeof err.response?.data === 'string'
  //         ? 'Erro ao salvar a configuração.'
  //         : err.response?.data?.detail;

  //     setFormErrors((prev) => ({
  //       ...prev,
  //       apiError: errorMessage,
  //       token: err.response?.data?.token,
  //       email: err.response?.data?.email,
  //     }));
  //   }
  // };

  const buscarInicializacao = async () => {
      try {
        const response = await get([
          `/pagamento-online/configuracoes/`,
          `/pagamento-online/instituicoes/?ativo=true`,
        ], 'pagina');
        if (response && response.length) {
          //alert(JSON.stringify(response[0]))
          setConfiguracoes(response[0].results);
          setInstituicoes(response[1].results);
        }
      } catch (err) {}
  };
  
  useEffect(() => {
    buscarInicializacao();
  }, []);
  
  const selectConfiguracao = (instituicao) => {
    return configuracoes.find(x => x.instituicao_pagamento === instituicao?.id);
  };
  
  
  return (<>
    <Card className="d-none">
      Instituicoes
      <code>{JSON.stringify(instituicoes)}</code>
      Configuracoes
      <code>{JSON.stringify(configuracoes)}</code>
      <Card.Body>
        
      </Card.Body>
    </Card>
    <div className="fs-5 text-center">
      Conecte seu banco para receber pagamentos de clientes direto via pix e cartões
    </div>
                <div className="list-group mt-3">
                    {instituicoes.length > 0 ? (
                      instituicoes.map((x) => (
                        <div className="border-top py-1 my-2">
                          <Row>
                            <Col xs={12}>
                              {x.instituicao_display} {selectConfiguracao(x)?.is_principal && "(Principal)"}
                              <div className="small text-mited">
                                {selectConfiguracao(x) ? (<>
                                  Instituição configurada e {selectConfiguracao(x)?.ativo?"ativa":"não está ativa"}
                                </>):(<>
                                  Instituição não configurada
                                </>)}
                                
                              </div>
                            </Col>
                            <Col className="text-end">
                              {selectConfiguracao(x) && (<>
                                {selectConfiguracao(x)?.ativo?(<>
                                  <Button size="sm" variant="danger" className="px-4 mx-1" onClick={()=>mudarStatus(x, false)}>Desativar</Button>
                                </>):(<>
                                  <Button size="sm" variant="success" className="px-4 mx-1" onClick={()=>mudarStatus(x, true)}>Ativar</Button>
                                </>)}
                              </>)}
                              <Button size="sm" variant="secondary" className="px-4 mx-1" onClick={()=>configurarInstituicao(x.instituicao)}>Configurar</Button>
                            </Col>
                          </Row>
                        </div>
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhuma instituição encontrada.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                </div>
  </>
  );
};

export default CondigurarPagamentoOnlineForm;